<wtf-dialogcontent [size]="'md'" [dialogTitle]="dialogTitle" (closeModal)="dialogRef.close()" [action]="action">
    <!-- Content -->

    <form name="companyForm" [formGroup]="companyForm" class="tax-type-form w-100-p p-20" fxLayout="column" fxFlex>
        <div fxLayout="row" fxLayoutAlign="end center">
            <mat-label>{{ "*Campos Obligatorios" | translate }}</mat-label>
        </div>
        <div class="active-container" fxFlex="1 0 auto" fxLayout="row" *ngIf="action !== recordAction.View">
            <mat-label>{{ "Activo" | translate }}</mat-label>
            <mat-slide-toggle name="isActive" formControlName="isActive" class="ms-2" aria-label="Active">
            </mat-slide-toggle>
        </div>
        <div class="labels" fxLayout="row" fxLayoutWrap fxShow.gt-sm *ngIf="action === recordAction.View">
            <div class="label" fxLayout="row" fxLayoutAlign="start center">
                <div class="label-color" [ngStyle]="{
                        'background-color': companyModel.isActive
                            ? 'green'
                            : 'red'
                    }"></div>
                <div class="label-title">Activo</div>
            </div>
        </div>
        <div class="label-container">
            <mat-label>{{ "Nombre de la Compañía" | translate }}*</mat-label>
        </div>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="name" formControlName="name" mat-maxlength="50"
                [readonly]="action === recordAction.View" required />
        </mat-form-field>
        @if (isControlValid(companyForm, "name")) {
        <div class="text-danger ng-mt-2">
            {{ getErrorMessage(companyForm, "name", "Nombre de la Compañía") }}
        </div>
        }
        <div class="label-container">
            <mat-label>{{ "RUC" | translate }}*</mat-label>
        </div>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="ruc" formControlName="ruc" mat-maxlength="50" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>
        <div class="label-container">
            <mat-label>{{ "Correo" | translate }}*</mat-label>
        </div>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="email" formControlName="email" mat-maxlength="50" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>
        @if (isControlValid(companyForm, "email")) {
        <div class="text-danger ng-mt-2">
            {{ getErrorMessage(companyForm, "email", "Correo") }}
        </div>
        }
        <div class="label-container">
            <mat-label>{{ "Número de Contacto" | translate }}*</mat-label>
        </div>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="phoneNumber" formControlName="phoneNumber" mat-maxlength="50" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>
        @if (isControlValid(companyForm, "phoneNumber")) {
        <div class="text-danger ng-mt-2">
            {{ getErrorMessage(companyForm, "phoneNumber", "Número de Contacto") }}
        </div>
        }
        <div class="label-container">
            <mat-label>{{ "Dirección" | translate }}*</mat-label>
        </div>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="address" formControlName="address" mat-maxlength="50" placeholder=""
                [readonly]="action === recordAction.View" required />
        </mat-form-field>
        <div class="label-container">
            <mat-label>{{ "URI" | translate }}*</mat-label>
        </div>
        <mat-form-field appearance="outline" class="w-100-p">
            <input matInput name="url" formControlName="url" mat-maxlength="50" placeholder="" autocomplete="off"
                required />
        </mat-form-field>

        <div *ngIf="showCompanies">
            <div class="label-container">
                <mat-label>{{ "Compañía principal" | translate }}*</mat-label>
            </div>
            <mat-form-field appearance="outline" class="w-100-p">
                <mat-select name="company_parent_id" formControlName="company_parent_id" placeholder=""
                    [disabled]="action === recordAction.View">
                    <mat-option *ngFor="let parent of parents" [value]="parent.id">{{ parent.name
                        }}</mat-option>
                </mat-select>
            </mat-form-field>
        </div>


        <div fxLayout="row" fxLayoutAlign="end end">
            <button *ngIf="action !== recordAction.Update" mat-raised-button (click)="performAction()"
                class="submit-button" [disabled]="companyForm.invalid" aria-label="GUARDAR">
                <span class="material-icons-outlined mr-20"> save </span>
                {{ "Guardar" | translate }}
            </button>

            <button *ngIf="action === recordAction.Update" mat-raised-button (click)="performAction()"
                class="submit-button" [disabled]="companyForm.invalid" aria-label="GUARDAR">
                <span class="material-icons-outlined mr-20"> save </span>
                {{ "Guardar" | translate }}
            </button>
        </div>
    </form>
    <!-- Content -->

    <!-- Buttons -->

    <!-- Buttons -->
</wtf-dialogcontent>